/*
// #1#
import Vue from 'vue';
import App from './App';
import VueRouter from 'vue-router';
import store from './store/store';

Vue.use(VueRouter);

// 定义路由组件
const Worldcloud = require('components/cloud.vue');
const Building = require('components/building.vue');
const Canteen = require('components/canteen.vue');
const Selfstudy = require('components/selfstudy.vue');
const Difficult = require('components/difficult.vue');
const Interest = require('components/interest.vue');
const Bedroom = require('components/bedroom.vue');
const Graduate = require('components/graduate.vue');
const Getup = require('components/getup.vue');
const Gotobed = require('components/gotobed.vue');
const Eat = require('components/eat.vue');
const Amuse = require('components/amuse.vue');
const Single = require('components/single.vue');
const Chat = require('components/chat.vue');
const Onlyme = require('components/onlyme.vue');

const HHome = require('components/hhome.vue');
const HPrice = require('components/hprice.vue');
const HDQty = require('components/hdqty.vue');
const HType = require('components/htype.vue');


// 定义路由
const routes = [
  { path: '/', redirect: '/wordcloud' },

  { path: '/home', component: HHome },
  { path: '/hprice', component: HPrice },
  { path: '/hdqty', component: HDQty },
  { path: '/htype', component: HType },

  { path: '/wordcloud', component: Worldcloud },
  { path: '/building', component: Building },
  { path: '/canteen', component: Canteen },
  { path: '/selfstudy', component: Selfstudy },
  { path: '/difficult', component: Difficult },
  { path: '/interest', component: Interest },
  { path: '/bedroom', component: Bedroom },
  { path: '/graduate', component: Graduate },
  { path: '/getup', component: Getup },
  { path: '/gotobed', component: Gotobed },
  { path: '/eat', component: Eat },
  { path: '/amuse', component: Amuse },
  { path: '/single', component: Single },
  { path: '/chat', component: Chat },
  { path: '/onlyme', component: Onlyme }
];

// 创建router实例
const router = new VueRouter({
  routes
});

// const store = new Vuex.Store({
//   state: {
//     islogin: false
//   },
//   mutations: {
//     enableLogin(state) {
//       state.islogin = true
//     },
//     disableLogin(state) {
//       state.islogin = false
//     }
//   }
// })
*/
/* eslint-disable no-new
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  router,
  store
});
*/


/*
// #2#
import Vue from 'vue'
import routes from './routes'
import VueResource from 'vue-resource'

Vue.use(VueResource);
Vue.http.options.emulateJSON = true;
Vue.http.options.emulateHTTP = true;

const app = new Vue({
  el: '#app',
  data: {
    currentRoute: window.location.pathname
  },
  computed: {
    ViewComponent () {
      const matchingView = routes[this.currentRoute]
      return matchingView
        ? require('./pages/' + matchingView + '.vue')
        : require('./pages/404.vue')
    }
  },
  render (h) {
    return h(this.ViewComponent)
  }
})

window.addEventListener('popstate', () => {
  app.currentRoute = window.location.pathname
})
*/

import auth from './auth'
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.http.options.emulateJSON = true
Vue.http.options.emulateHTTP = true

import VueECharts from 'vue-echarts/components/ECharts.vue'
// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
Vue.component('chart', VueECharts)


auth.setOpenid('ocwMjv_FhbsJTkhUNhAU7koY64Ps')
console.log('get openid:%s', auth.getOpenid())
console.log('get community:%s', auth.getCm())
console.log('get token:%s', auth.getToken())

const Home = {
  template: `
    <div class="home">
      <h2>Home</h2>
      <p>hello</p>
    </div>
  `
}

const Parent = {
  data () {
    return {
      transitionName: 'slide-left'
    }
  },
  // dynamically set transition based on route change
  watch: {
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    }
  },
  template: `
    <div class="parent">
      <nav class="navbar navbar-default" role="navigation">
        <div class="container-fluid">
          <div class="navbar-header">
            <router-link to="/main">
              <img alt="Brand" height="30" src="http://alpha-go.tech/wiki/lib/exe/fetch.php?cache=&media=alphago:back.png">
            </router-link>
          </div>

          <ul id="myTab" class="nav nav-pills " role="tablist">
            <!--li role="presentation"><a href="/detail/" data-toggle="tab">成交价格</a></li>
            <li role="presentation"><a href="/detail/qty" data-toggle="tab">成交量</a></li>
            <li role="presentation"><a href="/detail/type" data-toggle="tab">户型分布</a></li-->
            <li><router-link to="/detail/">成交价格</router-link></li>
            <li><router-link to="/detail/qty">成交量</router-link></li>
            <li><router-link to="/detail/type">户型分布</router-link></li>
          </ul>

        </div><!-- /.container-fluid -->
      </nav>



      <!--h2>Parent</h2>
      <ul>
        <li><router-link to="/detail">/detail</router-link></li>
        <li><router-link to="/detail/price">/detail/price</router-link></li>
        <li><router-link to="/detail/qty">/detail/qty</router-link></li>
        <li><router-link to="/detail/type">/detail/type</router-link></li>
      </ul-->
      <transition :name="transitionName">
        <router-view class="child-view"></router-view>
      </transition>
    </div>
  `
}

const HomeParent = {
  data () {
    return {
      transitionName: 'slide-left'
    }
  },
  // dynamically set transition based on route change
  watch: {
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    }
  },
  template: `

    <div class="parent">
      <nav class="navbar navbar-default" role="navigation">
        <div class="container-fluid">
          <div class="navbar-header">
            <div class="col-xs-2 header-img">
              <p><!--img src="http://wx.qlogo.cn/mmopen/7zVkCbG3KV0noJgWcib1eGVvXMBf7zuSsHduTMAOr7Q7cX5EibxLGwSTUVqqFywRCYEb1vbAoAEnceq7mSNUJqNzA3OAPzdMvX/0" class="img-responsive img-circle" alt="Responsive image"--></p>
            </div>
            <div class="col-xs-4 header-text">
              <p class="text-left bg-warning" id="head-username">{{name}}</p>
              <p class="text-left text-warning bg-info" id="head-coin">100 钢蹦</p>
            </div>
            <div class="col-xs-4"></div>
            <div class="col-xs-2 header-coin-img">
              <img src="http://alpha-go.tech/wiki/lib/exe/fetch.php?cache=&media=alphago:%E5%9B%BE%E8%A1%A8.png" class="img-responsive img-circle" alt="Responsive image">
            </div>
          </div>
        </div>
      </nav>
      <transition :name="transitionName">
        <router-view class="child-view"></router-view>
      </transition>
    </div>
  `
}

const Default = { template: '<div class="default">default</div>' }
const Foo = { template: '<div class="foo">foo</div>' }
const Bar = { template: '<div class="bar">bar</div>' }

// test case start
import Hhome from './pages/Home';
import Hprice from './pages/Hprice';
import Hdqty from './pages/Hdqty';
import Htype from './pages/Htype'
import Hpie from './pages/Hpie';

const Users = {
  template: `
    <div>
      <h2>Users</h2>
      <router-view></router-view>
    </div>
  `
}

const User = { template: '<div>{{ $route.params.username }}</div>' }

// test case end

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/home', component: Home },
    { path: '/testmain', component: Hhome },

    { path: '/main', component: HomeParent ,
      children: [
        { path: '', component: Hhome }
      ]
    },
    { path: '/detail', component: Parent,
      children: [
        //{ path: '', component: Foo },
        { path: '', component: Hprice },
        { path: 'qty', component: Hdqty },
        { path: 'type', component: Htype }
      ]
     },
    { path: '/users', component: Users,
      children: [
        { path: ':username', name: 'user', component: User }
      ]
    },
    { path: '/parent', component: Parent,
      children: [
        { path: '', component: Foo },
        { path: 'foo', component: Foo },
        { path: 'bar', component: Bar }
      ]
    },
    { path: '*', redirect: '/main' }
  ]
})

new Vue({
  router,
  template: `
    <div id="app">
      <!--h1>Transitions</h1>
      <ul>
        <li><router-link to="/">/</router-link></li>
        <li><router-link to="/detail/">/detail/price</router-link></li>
        <li><router-link to="/detail/qty">/detail/qty</router-link></li>
        <li><router-link to="/detail/type">/detail/type</router-link></li>

        <li><router-link :to="{ name: 'user', params: { username: 'evan' }, query: { foo: 'bar' }}" exact>
            /users/evan?foo=bar
          </router-link></li>
        <li><router-link to="/parent">/parent</router-link></li>
        <li><router-link to="/parent/foo">/parent/foo</router-link></li>
        <li><router-link to="/parent/bar">/parent/bar</router-link></li>
      </ul-->
      <transition name="fade" mode="out-in">
        <router-view class="view"></router-view>
      </transition>
    </div>
  `
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js